module.exports = __webpack_public_path__ + "static/media/account_balance_white.6b7e0378.svg";